export default __webpack_public_path__ + "static/media/home.c9a78ed4.svg";